export const BandAbbrvs = Object.freeze({
    ASOB: 'asob',
    BTMI: 'btmi',
    JR: 'jr',
    AV: 'av'
});